module.exports = __webpack_public_path__ + "img/kt-drbrian.a8dc51f6.jpg";